module.exports = __webpack_public_path__ + "static/img/yyxb.e30d7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yyxb.png
// module id = xia2
// module chunks = 1